/**
 * Conversões entre base64url (formato do WebAuthn/VAPID) e bytes.
 *
 * O navegador trabalha com ArrayBuffer, enquanto o backend (JSON) usa
 * base64url sem padding. Estes helpers evitam dependências extras.
 */

export const base64urlParaUint8Array = (valor) => {
  const texto = String(valor || '')
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const padding = '='.repeat((4 - (texto.length % 4)) % 4);
  const binario = window.atob(texto + padding);
  const bytes = new Uint8Array(binario.length);

  for (let indice = 0; indice < binario.length; indice += 1) {
    bytes[indice] = binario.charCodeAt(indice);
  }

  return bytes;
};

export const bufferParaBase64url = (valor) => {
  if (!valor) return '';

  const bytes = valor instanceof Uint8Array ? valor : new Uint8Array(valor);
  let binario = '';

  for (let indice = 0; indice < bytes.length; indice += 1) {
    binario += String.fromCharCode(bytes[indice]);
  }

  return window.btoa(binario).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

const base64url = { base64urlParaUint8Array, bufferParaBase64url };

export default base64url;
